import React from 'react';
import '../css/D2H.css';
import Cookies from 'js-cookie';
import _ from 'lodash';
import Sorting from './Sorting';
import SearchBar from './SearchBar';
// import SearchBar from 'material-ui-search-bar'
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import edit from './../assets/images/edit.svg';
import view from './../assets/images/view.svg';
import deleteIcon from './../assets/images/delete.svg';
import Loader from './Loader';
import AddChannelModal from './AddChannelModal';
import EditChannelModal from './EditChannelModal';
import Modal from 'react-modal';
// import createHistory from 'history/createBrowserHistory';


//d2h list data 

const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
    backgroundColor: '#EFF3F6'
  }
};
class D2HList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logData: [],
      sortedType: '',
      searchValue: '',
      actualData: [],
      searchActive: false,
      loadSpinner: true,
      currentChannelToEdit: {},
      modalIsOpenAddChannel: false,
      modalIsOpenEditChannel: false,
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      modalIsOpenDeleteSuccess: false,
    }
    this.closeModalDelete = this.closeModalDelete.bind(this);

  }
  componentDidMount() {
    this.d2hList();
    this.resetSearchBar()

  }

  restoreData = (data) => {
    this.setState({
      logData: data
    })
  }
  
  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }

  refreshChannels = (e) => {
    this.setState({
      modalIsOpenAddChannel: false,
      modalIsOpenEditChannel: false
    }, () => {
      this.d2hList();
    })
  }


  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddChannel || this.state.modalIsOpenSuccess || this.state.modalIsOpenEditChannel) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
  }



  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.logData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.logData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.logData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.logData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }
  resetSearchBar = () =>{
    this.props.searchBarActivate(false)
  }
  
  
  ActivateAddChannelModel = (type) => {    
    if (this.state.modalIsOpenAddChannel) {
      return <AddChannelModal activeModal={true} refreshDevices={this.refreshChannels.bind(this)}/>
    } else {
      return null
    }
  }
  ActivateEditChannelModel = (type) => {    
    if (this.state.modalIsOpenEditChannel) {
      return <EditChannelModal activeModal={true} refreshDevices={this.refreshChannels.bind(this)} currentChannel={this.state.currentChannelToEdit}/>
    } else {
      return null
    }
  }



  d2hList = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/d2hlistApi', {
      method: "GET",
      headers: headers,
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href = '/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        if(!this.props.redux.auth.searchBarShow){
          this.setState({
            logData: data,
            actualData: data
          }, () => {
            this.setState({
              loadSpinner: false
            })
          })          
        }else{
          this.setState({
            logData: data,
            actualData: data
          }, () => {
            this.setState({
              loadSpinner: false
            })
            this.sortingFunc('search', this.state.searchValue)
          })        
        }
      })
  }



  overlayShadowUnderModal = () => {
    if (this.state.modalIsOpenAddChannel || this.state.modalIsOpenEditChannel) {
      return (
        <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
      )
    } else {
      return null
    }
  }

  openModal() {
    this.setState({
      modalIsOpenAddChannel: false
    }, () => {
      this.setState({
        modalIsOpenAddChannel: true
      })
    })
  }

  openModalEdit() {
    this.setState({
      modalIsOpenEditChannel: false
    }, () => {
      this.setState({
        modalIsOpenEditChannel: true
      })
    })
  }

  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  

  obDatatable = () => { 
      return this.state.logData.map((event, index) => {
        return (
          <React.Fragment>
            <tr key={index} className="some-hover">
              <td scope="col" style={{ width: '10%',minWidth: '150px', verticalAlign: 'middle', }}>{event.channel_number}</td>
              <td scope="col" style={{ width: '20%', verticalAlign: 'middle', }}>{event.channel_name}</td>
              <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{event.language}</td>
              <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{event.genre}</td>
              <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{event.description}</td>
              <td style={{ width: '150px', textAlign: 'left' }}>
            {/* <span>
              <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} />
            </span>            */}
              <span className="d-inline-block">
                <span>
                  <img src={edit} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} 
                  onClick={(e)=>{
                    this.setState({
                      currentChannelToEdit: event,
                      modalIsOpenEditChannel:true 
                    })
                    }} />
                </span>
              </span>
              <span className="d-inline-block">
                <span>
                  <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }}
                                    onClick={(e)=>{
                                      this.setState({
                                        currentChannelToEdit: event,
                                        modalIsOpenDelete:true 
                                      })
                                      }}
                  />
                </span>
              </span>            
          </td>
            </tr>
          </React.Fragment>
        )
      })   
  }

  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/d2hlistApi_detail/${this.state.currentChannelToEdit.ID}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        return response.json()})
      .then(data => {
        this.d2hList()
          this.setState({
            modalIsOpenDelete:false,
            modalIsOpenDeleteSuccess: true
          })
      })
      .catch((err)=>{
        console.log(err)
      })
  }


  render() {
    return (
      <React.Fragment>
         {this.state.loadSpinner ? <Loader /> : null}
        {this.overlayShadowUnderModal()}
        <div style={{ paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px', height: `${window.innerHeight - 120}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>ALL CHANNELS - ({this.state.actualData.length})</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer"
                  onClick={() => {
                    this.openModal()
                  }
                  } >
                  <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                    <span style={{ color: '#888888', fontSize: '15px', fontWeight: '600' }}>ADD CHANNEL</span>
                  </div>
                </div>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
              <SearchBar autoFocus
                value={this.state.searchValue}
                onChange={(e) => {
                  this.setState({
                    searchValue: e
                  }, () => {
                    this.sortingFunc('search', this.state.searchValue)
                  })
                }
                }
                onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                resetSearch = {(e)=>{
                  this.setState({
                    searchValue: e
                  }, () => {
                    this.sortingFunc('search', '')
                  })
                }}
              /></div>}
          <div className="si-lisst col-s12">
            {this.state.addAnotherSuccess}
            <table className="table">
              <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                <th scope="col" style={{ width: '10%', minWidth: '150px', verticalAlign: 'middle' }}>Number
          <i class={this.fetchIconType('channel_number')} onClick={(e) => { this.sortingFunc('channel_number') }}></i>
                </th>
                <th scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>Name
          <i class={this.fetchIconType('channel_name')} onClick={(e) => { this.sortingFunc('channel_name') }}></i>
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Language
          <i class={this.fetchIconType('language')} onClick={(e) => { this.sortingFunc('language') }}></i>
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Genre
          <i class={this.fetchIconType('genre')} onClick={(e) => { this.sortingFunc('genre') }}></i>
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Description</th>
                <th scope="col" style={{ width: '10%', verticalAlign: 'middle' }}>Action
                </th>
              </thead>
              <tbody style={{ overflowY: 'overlay' ,maxHeight: `${window.innerHeight - 280}px` }}>
                {this.obDatatable()}
              </tbody>
            </table>
          </div>
        </div>
        {this.ActivateAddChannelModel()}
        {this.ActivateEditChannelModel()}
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion? </h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" 
            onClick={this.onDeleteFinal.bind(this)}
            >Delete </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })
              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Channel  deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
            }}>Close</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(D2HList);